const theArray = [];
Object.freeze(theArray);
/**
 * Returns the same instance of an empty immutable array.
 *
 * @example
 * ```
 *   const { userList: data = emptyArray() } = useQuery("users", getUsers);
 * ```
 */
export const emptyArray = () => theArray;
//# sourceMappingURL=emptyArray.js.map